import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'
import { buildParams } from '@/ui/utils/buildParams'

import { ResponsibleMedicalRecordLink } from '../../domain/models/MedicalRecordLink'
import { ResponsibleMedicalRecord } from '../../domain/models/ResponsibleMedicalRecord'
import { ResponsibleMedicalRecordReview } from '../../domain/models/ResponsibleMedicalRecordReview'
import { ResponsibleMedicalRecordSummaryList } from '../../domain/models/ResponsibleMedicalRecordSummary'
import { ResponsibleMedicalRecordView } from '../../domain/models/ResponsibleMedicalRecordView'
import { ResponsibleMedicalRecordDatasource } from '../../infra/datasources/ResponsibleMedicalRecordDatasource'

export const responsibleMedicalRecordDatasourceAdapter: ResponsibleMedicalRecordDatasource =
  {
    async getResponsibleMedicalRecord({ id }) {
      const response = await HTTPExceptionInterceptor(
        await fetch(`${API_URL}/v1/responsible-medical-record/${id}`, {
          method: 'GET'
        })
      )

      const json = ResponsibleMedicalRecord.parse(await response.json())
      return json
    },
    async updateResponsibleMedicalRecord({ data, id }) {
      await HTTPExceptionInterceptor(
        await fetch(`${API_URL}/v1/responsible-medical-record/${id}`, {
          method: 'PUT',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        })
      )
    },
    async setResponsibleMedicalRecordExpired({ id }) {
      await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/responsible-medical-record/${id}/expired`,
            httpTokenInterceptor({
              method: 'PUT'
            })
          )
        )
      )
    },
    async setResponsibleMedicalRecordCompleted({ id }) {
      await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/responsible-medical-record/${id}/completed`,
            httpTokenInterceptor({
              method: 'PUT'
            })
          )
        )
      )
    },
    async createResponsibleMedicalRecordLink({ patientId }) {
      const response = await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/patients/${patientId}/links`,
            httpTokenInterceptor({
              method: 'POST'
            })
          )
        )
      )

      const json = ResponsibleMedicalRecordLink.parse(await response.json())
      return json
    },
    async listResponsibleMedicalRecord(params) {
      const searchParams = buildParams(params)

      const response = await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/responsible-medical-record?${searchParams}`,
            httpTokenInterceptor({
              method: 'GET'
            })
          )
        )
      )

      const json = ResponsibleMedicalRecordSummaryList.parse(
        await response.json()
      )
      return json
    },
    async getResponsibleMedicalRecordForReview({ id }) {
      const response = await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/responsible-medical-record/${id}/review`,
            httpTokenInterceptor({
              method: 'GET'
            })
          )
        )
      )

      const json = ResponsibleMedicalRecordReview.parse(await response.json())
      return json
    },
    async getResponsibleMedicalRecordForView({ id }) {
      const response = await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/responsible-medical-record/${id}/view`,
            httpTokenInterceptor({
              method: 'GET'
            })
          )
        )
      )

      const json = ResponsibleMedicalRecordView.parse(await response.json())
      return json
    },
    async reviewResponsibleMedicalRecord({
      patientId,
      responsibleMedicalRecordId,
      data
    }) {
      await HTTPExceptionInterceptor(
        await httpAuthenticationInterceptor(
          await fetch(
            `${API_URL}/v1/patients/${patientId}/verified-data-medical/${responsibleMedicalRecordId}`,
            httpTokenInterceptor({
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json'
              }
            })
          )
        )
      )
    }
  }
